import universityIcon from '@ucheba/ui/icons/icon__university.svg'
import scalesIcon from '@ucheba/ui/icons/icon__scales.svg'
import graduationCapIcon from '@ucheba/ui/icons/icon__graduation-cap.svg'
import listViewIcon from '@ucheba/ui/icons/icon__list-view.svg'
import searchIcon from '@ucheba/ui/icons/icon__search.svg'
import likeIcon from '@ucheba/ui/icons/icon__like.svg'
import bowTieIcon from '@ucheba/ui/icons/icon__bow-tie.svg'
import { EIconName, IUseTeachersListWithIcons, TIconName } from './types'

export const useTeachersListWithIcons: IUseTeachersListWithIcons = (list) => {
  if (!list) return null

  const Icon = (iconName: TIconName): string => {
    switch (iconName) {
      case EIconName.university:
        return universityIcon
      case EIconName.scales:
        return scalesIcon
      case EIconName.graduationCap:
        return graduationCapIcon
      case EIconName.listView:
        return listViewIcon
      case EIconName.search:
        return searchIcon
      case EIconName.like:
        return likeIcon
      case EIconName.bowTie:
        return bowTieIcon

      default:
        return ''
    }
  }

  return list.map((el) => ({ ...el, Icon: Icon(el.iconName as TIconName) }))
}
